<template>
    <SectionBasicLayout>
      <template #content>
        <div class="push-center user-dashboard">

          <NotificationMessages zone="user_dashboard" content_class="inline"/>

          <UserAvatar></UserAvatar>

          <div class="dashboard-actions">
              <h3>{{ Language.say('user_dashboard.my_account') }}</h3>
              <a :href="links.sso_profile" target="_blank" class="button clear">
                  <span class="menu-title">{{ Language.say('user_dashboard.my_profile') }} <i class="fas fa-external-link-alt"></i></span>
              </a>
              <a :href="links.password_reset" target="_blank" class="button clear">
                  <span class="menu-title">{{ Language.say('user_dashboard.password_reset') }} <i class="fas fa-external-link-alt"></i></span>
              </a>
              <a :href="links.manage_recover" target="_blank" class="button clear">
                  <span class="menu-title">{{ Language.say('user_dashboard.manage_recover') }} <i class="fas fa-external-link-alt"></i></span>
              </a>

              <a :href="links.premium" target="_blank" class="button clear" v-if="account_controller.account.premium.enabled">
                  <span class="menu-title">{{ Language.say('user_dashboard.manage_premium') }} <i class="fas fa-external-link-alt"></i></span>
              </a>
          </div>

          <UserQuota></UserQuota>

          </div>
      </template>
    </SectionBasicLayout>
</template>

<script setup>
  import {reactive, ref, watch}  from 'vue';
  import SectionBasicLayout      from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
  import NotificationMessages    from '@/vue/Elements/Tools/Notifications/NotificationMessages.vue';
  import UserAvatar              from '@/vue/Views/Webmail/Partials/UserAvatar.vue';
  import UserQuota               from '@/vue/Views/Webmail/Partials/UserQuota.vue';
  import NotificationsController from '@/js/Webmail/Notifications/NotificationsController';
  import MailboxController       from '@/js/Mailboxes/MailboxController.js';
  import Language                from '@/js/Shared/Language/Language.js';
  import SAPOMailConfig          from '@/SAPOMailConfig';
  import AccountController       from '@/js/Webmail/AccountController';

  const links              = SAPOMailConfig.server.external_links;
  const controller         = reactive(MailboxController);
  const quota_set          = ref(false);
  const account_controller = AccountController;

  watch(() => controller.quota.storage_virtual_percentage, () => {
    NotificationsController.removeNotification('user_dashboard.quota_warning');

    if (controller.quota.storage_virtual_percentage >= 90) {

      let options = {
        zones: ['user_dashboard'],
        auto_dismiss: false,
      };

      if (AccountController.account.premium.allowed === true) {
        options = {
          ...options,
          message_type: "text_link",
          link_text: 'Aderir ao Premium',
          link_icon: 'fas fa-external-link-alt',
          link_class: 'link',
          link_type: 'external',
          link: links.premium,
        }
      }

      NotificationsController.addWarning('user_dashboard.quota_warning', [controller.quota.storage_virtual_percentage], options);
    }
  });
</script>